import React from 'react';
import { Instagram, Linkedin, Twitter, Facebook } from 'lucide-react';
import { company, navLinks, services } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-ivory border-t border-line">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={company.logo}
                alt="KMH & Associates logo"
                className="h-16 w-auto object-contain"
              />
              <div>
                <span className="font-serif-display text-xl text-ink">KMH &amp; Associates</span>
                <p className="font-mono-label text-gold-dark text-[0.6rem]">Company Secretaries · Est. {company.founded}</p>
              </div>
            </div>
            <p className="font-sans-body text-base text-muted-kmh leading-relaxed mt-6 max-w-md">
              A professional company secretarial and business advisory firm — architecting bullet-proof
              compliance frameworks for India’s most ambitious enterprises.
            </p>
            <div className="flex items-center gap-3 mt-8">
              {[Linkedin, Instagram, Twitter, Facebook].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 rounded-full border border-line hover:border-gold hover:bg-gold/10 flex items-center justify-center"
                  aria-label="social"
                >
                  <I className="w-4 h-4 text-ink-soft" strokeWidth={1.4} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="font-mono-label text-gold-dark mb-6">Navigate</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="link-underline font-sans-body text-ink-soft hover:text-ink">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono-label text-gold-dark mb-6">Practice</p>
            <ul className="space-y-3">
              {services.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`} className="link-underline font-sans-body text-ink-soft hover:text-ink">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-line flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <p className="font-sans-body text-sm text-muted-kmh">
            © {new Date().getFullYear()} KMH &amp; Associates. All rights reserved.
          </p>
          <div className="flex items-center gap-6 font-mono-label text-muted-kmh">
            <a href="#" className="hover:text-ink">Privacy</a>
            <a href="#" className="hover:text-ink">Terms</a>
            <a href="#" className="hover:text-ink">Cookies</a>
          </div>
        </div>
      </div>

      {/* Ticker */}
      <div className="bg-ink text-ivory overflow-hidden border-t border-gold/30">
        <div className="flex animate-ticker whitespace-nowrap py-5">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex items-center gap-12 px-6">
              {['PoSH', 'Secretarial', 'Fundraising', 'NBFC', 'FEMA', 'LLP', 'Entity Formation', 'Governance', 'Advisory'].map((t, i) => (
                <span key={i} className="flex items-center gap-12 font-serif-display text-3xl lg:text-5xl italic text-ivory/80">
                  {t}
                  <span className="text-gold">•</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
